export default function getDaysInMonth(year: number, month: number): number[] {
  const firstDay = new Date(year, month - 1, 1);

  const lastDay = new Date(year, month, 0);

  const days: number[] = [];

  for (let day = firstDay.getDate(); day <= lastDay.getDate(); day++) {
    days.push(day);
  }

  return days;
}
